document.addEventListener('click', (event) => {
  const fullDetails = event.target.closest('[data-rack-full-details]');
  if (fullDetails) {
    document.querySelector('.rack-product-content [data-rack-tab="description"]')?.click();
  }
  const tab = event.target.closest('[data-rack-tab]');
  if (!tab) return;
  const section = tab.closest('.rack-product-content');
  if (!section) return;
  const selected = tab.dataset.rackTab;
  section.querySelectorAll('[data-rack-tab]').forEach((item) => {
    const active = item === tab;
    item.classList.toggle('is-active', active);
    item.setAttribute('aria-selected', String(active));
    item.tabIndex = active ? 0 : -1;
  });
  section.querySelectorAll('[data-rack-panel]').forEach((panel) => {
    panel.hidden = panel.dataset.rackPanel !== selected;
  });
});

document.addEventListener('shopify:block:select', (event) => {
  if (!(event.target instanceof Element)) return;
  const section = event.target.closest('.rack-product-content');
  if (!section) return;
  const selectedTab = event.target.closest('[data-rack-tab]');
  if (selectedTab) selectedTab.click();
  const panel = event.target.closest('[data-rack-panel]');
  if (panel) {
    section.querySelector(`[data-rack-tab="${panel.dataset.rackPanel}"]`)?.click();
  }
});

document.addEventListener('keydown', (event) => {
  const tab = event.target.closest('[data-rack-tab]');
  if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
  const tabs = [...tab.closest('.rack-product-content').querySelectorAll('[data-rack-tab]')];
  const index = tabs.indexOf(tab);
  let next = index;
  if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
  if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
  if (event.key === 'Home') next = 0;
  if (event.key === 'End') next = tabs.length - 1;
  event.preventDefault();
  tabs[next].focus();
  tabs[next].click();
});

function selectedProductHeight(optionPosition) {
  const options = document.querySelectorAll('product-info[id^="MainProduct"] variant-selects .product-form__input');
  const heightOption = options[optionPosition - 1];
  const selectedHeight = heightOption?.querySelector('input:checked')?.value || heightOption?.querySelector('select')?.value;
  return selectedHeight?.trim().toUpperCase().replace(/\s+/g, '');
}

function syncHeightDetailImages() {
  document.querySelectorAll('[data-rack-detail-image]').forEach((detail) => {
    const filter = detail.dataset.heightFilter || 'all';
    const position = Number(detail.dataset.heightOptionPosition);
    const height = position > 0 ? selectedProductHeight(position) || detail.dataset.selectedHeight : '';
    const visible = filter === 'all' || (position > 0 && height === filter);
    detail.hidden = !visible;
    if (!visible) return;
    const template = detail.querySelector('template[data-rack-detail-image-template]');
    if (template) {
      detail.append(template.content.cloneNode(true));
      template.remove();
    }
  });
}

function syncHeightLinks() {
  syncHeightDetailImages();
  document.querySelectorAll('[data-rack-height-manual]').forEach((manual) => {
    const height = selectedProductHeight(Number(manual.dataset.heightOptionPosition));
    const link = manual.querySelector('.rack-product-content__manual-option');
    const name = manual.querySelector('[data-rack-manual-name]');
    if (!link || !name || !height) return;

    if (height === '9FT' || height === '12FT') {
      link.href = height === '12FT' ? manual.dataset.manualTwelveUrl : manual.dataset.manualNineUrl;
      name.textContent = `${height} installation guide`;
      link.hidden = false;
    } else {
      link.hidden = true;
    }
  });

  document.querySelectorAll('[data-rack-height-amazon]').forEach((link) => {
    const height = selectedProductHeight(Number(link.dataset.heightOptionPosition));
    const configuredUrl = height === '12FT' ? link.dataset.amazonTwelveUrl : height === '9FT' ? link.dataset.amazonNineUrl : '';
    if (!height) return;
    const destination = configuredUrl || link.dataset.amazonDefaultUrl;
    if (destination) {
      link.href = destination;
      link.removeAttribute('aria-disabled');
    } else {
      link.removeAttribute('href');
      link.setAttribute('aria-disabled', 'true');
    }

    const copyButton = link.closest('product-info')?.querySelector('[data-rack-coupon-copy]');
    if (!copyButton) return;
    if (copyButton.dataset.defaultCopiedUrl === undefined) {
      copyButton.dataset.defaultCopiedUrl = copyButton.dataset.copiedUrl || '';
    }
    copyButton.dataset.copiedUrl = configuredUrl || copyButton.dataset.defaultCopiedUrl;
  });
}

function removeEmptyDescriptionItems(root = document) {
  root.querySelectorAll('.rack-product-content__description li').forEach((item) => {
    if (!item.textContent.trim() && !item.querySelector('img, svg, video, iframe, input, button')) {
      item.remove();
    }
  });
}

document.addEventListener('change', (event) => {
  if (event.target.closest('product-info variant-selects')) syncHeightLinks();
});
document.addEventListener('DOMContentLoaded', () => {
  syncHeightLinks();
  removeEmptyDescriptionItems();
});
document.addEventListener('shopify:section:load', (event) => {
  syncHeightLinks();
  removeEmptyDescriptionItems(event.target);
});
